export default __webpack_public_path__ + "static/media/gold-3.37f23687.png";